const ContractAddrList = {
  punks: "0xb47e3cd837dDF8e4c57F05d70Ab865de6e193BBB",
  toadz: "0x1CB1A5e65610AEFF2551A50f76a87a7d3fB649C6",
  bayc: "0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D",
  coolcats: "0x1A92f7381B9F03921564a437210bB9396471050C",
  blitnauts: "0x448f3219CF2A23b0527A7a0158e7264B87f635Db",
  creature: "0xc92ceddfb8dd984a89fb494c376f9a48b999aafc",
  deadfellas: "0x2acAb3DEa77832C09420663b0E1cB386031bA17B",
  doodles: "0x8a90cab2b38dba80c64b7734e58ee1db38b8992e",
  metahero: "0x6dc6001535e15b9def7b0f6a20a2111dfa9454e2",
  groupies: "0x4f89cd0cae1e54d98db6a80150a824a533502eea",
}

export default ContractAddrList;
